<template>
  <div class="onboaring-div feature-onboarding-div">
    <div class="overlay">
      <div class="onbaording-parent feature-onboarding">
        <div class="feature-onboarding-header text-center">
          <h4>{{content['title']}}</h4>
          <p v-html="content['body']"></p>
        </div>
        <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null">
          <tab-content class="mb-12" v-for="image in images" :key="image">
            <feature-content :image="image"> </feature-content>
          </tab-content>

          <template slot="footer" slot-scope="props">
            <div class="flex justify-between" v-if="props.isLastStep">
              <div class="text-left">
                <!-- Back btn -->
                <button v-if="backBtnCTA" class="wizard-back-button speakol-color" @click="handleCTA(backBtnCTA); props.prevTab(); $gtag.event('Feature_Onboarding_Back_Btn')">
                {{backBtnCTA['title']}}
                </button>
              </div>

              <div v-if="props.isLastStep" class="text-right">
                <!-- Finish btn -->
                <button
                  v-if="finishBtnCTA"
                  class="wizard-start-button"
                  @click="handleCTA(finishBtnCTA); $emit('completed');$gtag.event('Feature_Onboarding_Finish_Btn')">
                  {{finishBtnCTA['title']}}
                </button>
              </div>
            </div>

              <!-- Skip btn -->
            <div v-else class="flex justify-between">
              <button
                v-if="skipBtnCTA"
                class="wizard-skip-button"
                @click="handleCTA(skipBtnCTA); $emit('completed');$gtag.event('Feature_Onboarding_Skip_Btn')">
                {{skipBtnCTA['title']}}
              </button>

              <!-- Next btn -->
              <wizard-button
                v-if="nextBtnCTA"
                class="wizard-next-button"
                @click.native="props.nextTab(); handleCTA(nextBtnCTA);$gtag.event('Feature_Onboarding_Next_Btn')">
                {{nextBtnCTA['title']}}
              </wizard-button>
            </div>
          </template>
        </form-wizard>
      </div>
    </div>
  </div>
</template>

<script>
import {FormWizard, TabContent, WizardButton} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import FeatureContent from './components/FeatureContent'

export default {
  props: ['feature'],
  data () {
    return {
      content: [],
      images: [],
      skipBtnCTA:[],
      nextBtnCTA: [],
      finishBtnCTA: [],
      backBtnCTA: []
    }
  },

  async mounted () {
    this.setNotificationContent()
  },
  components: {
    FormWizard,
    TabContent,
    FeatureContent,
    WizardButton
  },
  methods: {
    setNotificationContent () {
      this.content = this.feature['data'] || []
      this.images = this.feature['data'] && this.feature['data']['images'] ? this.feature['data']['images'] : []
      this.skipBtnCTA = this.getButton('skip')
      this.nextBtnCTA = this.getButton('next')
      this.finishBtnCTA = this.getButton('finish')
      this.backBtnCTA = this.getButton('back')
    },

    async handleCTA (cta) {
      this.$gtag.event(`Notification-Actions-'${cta.action}`)
      await window.axios.post('/notifications-center/event', {
        notifications_ids: [this.feature['id']],
        event_name: cta.action,
        tags: this.$constants.ONBOARDING_NOTIFICATIONS_TAGS,
        is_viewed: 0,
        hideLoader: true
      })
    },

    getButton (action) {
      return this.feature['ctas'].find((cta) => {
        return cta['action'] === action
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.feature-onboarding-header {
  h4 {
    color: #000;
    font-weight: 500;
    font-size: 24px;
    margin-bottom: 20px;
    margin-top: 18px;
    padding-left: 20px;
    padding-right: 20px;
  }

  p {
    color: #000;
    font-size: 16px;
    font-weight: 300;
    padding-left: 20px;
    padding-right: 20px;
  }
}

.wizard-next-button {
  background-color: #0092d7 !important;
  border-radius: 4px !important;
  width: 110px !important;
  height: 36px !important;
  color: white !important;
  font-size: 14px !important;
  font-weight: 300 !important;
}

.wizard-skip-button,
.wizard-back-button {
  background-color: white !important;
  border-radius: 4px !important;
  width: 110px !important;
  height: 36px !important;
  color: #0092d7 !important;
  font-size: 14px !important;
  font-weight: 300 !important;
  border: 1px solid #0092d7 !important;
  cursor: pointer;
}

.wizard-start-button {
  background-color: #0092d7 !important;
  border-radius: 4px !important;
  width: 110px !important;
  height: 36px !important;
  color: white !important;
  font-size: 14px !important;
  font-weight: 300 !important;
  cursor: pointer;
  outline: none;
  border: none;
}

.vue-form-wizard {
  padding-bottom: 0 !important;
}

.wizard-card-footer {
  padding: 0 !important;
}

.wizard-tab-content {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.feature-onboarding {
  width: auto !important;
}

.feature-onboarding-div {
  .wizard-header {
    display: none !important;
  }

  .overlay {
    background-color: rgba(112, 112, 112, 0.8);
  }

  .onbaording-parent {
    padding: 20px 0;
  }

  /deep/ .wizard-tab-content {
    padding: 9px 0 0 0 !important;
  }
}

@media (max-width: 768px) {
  .feature-onboarding-div {
    .feature-onboarding {
      width: 91% !important;
    }

    .wizard-next-button,
    .wizard-skip-button,
    .wizard-back-button,
    .wizard-start-button {
      width: 140px !important;
    }
  }
}
</style>
